import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';

@Component({
    selector: 'sn-usc-p2w-competition-status',
    templateUrl: './usc-p2w-competition-status.component.html',
    styleUrls: ['./usc-p2w-competition-status.component.css']
})
export class UscP2wCompetitionStatusComponent implements OnInit {
@Input() competition_ID: number;

    public scope_types: any[] = [];
    public scope_type: string = "channel";
    public selected_scope_type: { name: '' }

    constructor(
        public elementRef: ElementRef,
        public uscStoreService: UscStoreService,
    ) { }

    ngOnInit() {

        this.scope_types.push({ name: "National", value: "channel", selected: this.scope_type == "channel" });
        this.scope_types.push({ name: "Region", value: "region", selected: this.scope_type == "region" });
        this.scope_types.push({ name: "Territory", value: "territory", selected: this.scope_type == "territory" });
        this.scope_types.push({ name: "Area", value: "area", selected: this.scope_type == "area" });
        this.scope_types.push({ name: (this.uscStoreService.isUSCellTelesales() ? "Pod" : "Store"), value: "store", selected: this.scope_type == "store" });

        this.selected_scope_type = this.scope_types[0];
    }

}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-p2w-competition-status/usc-p2w-competition-status.component.ts